import store from "./store"
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import App from "./containers/appWrap";
import { initializeFirebase } from './push-notification';

import { getCurrentUser } from "./actions/session";

import './css/global.css';
import './css/adaptive.css';

window.siteUrl = '';
if (process.env.NODE_ENV && process.env.NODE_ENV === 'development') {
    window.siteUrl = 'https://fixfact.ru';
}

initializeFirebase();

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("page")
);


// WEBPACK FOOTER //
// ./src/index.js